import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash.get';
import { gql } from '@selfdetermine/graphql';
import { useQuery } from '@selfdetermine/react-hooks';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    query {\n      viewer {\n        self {\n          permissions {\n            type\n            can\n          }\n        }\n      }\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var PermissionsContext = /*#__PURE__*/React.createContext({
  roles: []
});
var PermissionsProvider = function PermissionsProvider(_ref) {
  var _request$data, _request$data$viewer, _request$data$viewer$, _request$data$viewer$2;

  var children = _ref.children;
  var request = useQuery(gql(_templateObject()));

  if (request.loading) {
    return false;
  } // Format permissions into an object for easier lookup


  var permissions = (request === null || request === void 0 ? void 0 : (_request$data = request.data) === null || _request$data === void 0 ? void 0 : (_request$data$viewer = _request$data.viewer) === null || _request$data$viewer === void 0 ? void 0 : (_request$data$viewer$ = _request$data$viewer.self) === null || _request$data$viewer$ === void 0 ? void 0 : (_request$data$viewer$2 = _request$data$viewer$.permissions) === null || _request$data$viewer$2 === void 0 ? void 0 : _request$data$viewer$2.reduce(function (groupedPermissions, permission) {
    return _objectSpread2(_objectSpread2({}, groupedPermissions), {}, _defineProperty({}, permission.type.toLowerCase(), permission.can.reduce(function (permittedActions, action) {
      return _objectSpread2(_objectSpread2({}, permittedActions), {}, _defineProperty({}, action.toLowerCase(), true));
    }, {})));
  }, {})) || {};
  return /*#__PURE__*/React.createElement(PermissionsContext.Provider, {
    value: {
      permissions: permissions
    }
  }, children);
};
PermissionsProvider.propTypes = {
  children: PropTypes.element
};
/**
 * React hook that returns whether the user has access or not to the specified feature.
 *
 * @param {string} permissionName - Name of permission
 * @returns {boolean} True if the user has access
 */

var usePermission = function usePermission() {
  var _permissions$all;

  var permissionName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  var _React$useContext = React.useContext(PermissionsContext),
      permissions = _React$useContext.permissions;

  var userCanManageEverything = ((_permissions$all = permissions.all) === null || _permissions$all === void 0 ? void 0 : _permissions$all.manage) || false;
  var permission = get(permissions, permissionName === null || permissionName === void 0 ? void 0 : permissionName.toLowerCase());
  return permission || userCanManageEverything;
};
/**
 * Component version of the `usePermission` hook. Renders children if the user has permission to
 * the specified feature, otherwise a `renderFallback` may be provided to render when the user
 * doesn't actually have permission.
 */

var PermissionRequired = function PermissionRequired(_ref2) {
  var name = _ref2.name,
      _ref2$renderFallback = _ref2.renderFallback,
      renderFallback = _ref2$renderFallback === void 0 ? false : _ref2$renderFallback,
      children = _ref2.children;
  var hasPermission = usePermission(name);

  if (!hasPermission) {
    return renderFallback;
  }

  return children;
};

export { PermissionRequired, PermissionsContext, PermissionsProvider, usePermission };
